import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Search from '../../../component/common/Search';
import SuppliersTable from '../../../component/supplier/SuppliersTable';
import Pagination from '../../../component/common/Pagination';
import SpinnerLoading from '../../../component/common/SpinnerLoading';

export class SuppliersListContainer extends React.Component {
  static propTypes = {
    suppliers: PropTypes.array,
    suppliersCount: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    companyId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    onSwitchFavorite: PropTypes.func.isRequired,
    search: PropTypes.string.isRequired,
    setSearch: PropTypes.func.isRequired,
    onSwitchPage: PropTypes.func.isRequired,
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  render() {
    const {
      suppliers,
      suppliersCount,
      limit,
      companyId,
      projectId,
      history,
      onSwitchFavorite,
    } = this.props;
    return !suppliers ? (
      <SpinnerLoading centered={true} />
    ) : (
      <div className="suppliers-table-container">
        <label className="page-header">Suppliers</label>
        <Search search={this.props.search} setSearch={this.props.setSearch} />
        <SuppliersTable
          suppliers={suppliers}
          companyId={companyId}
          projectId={projectId}
          history={history}
          onSwitchFavorite={onSwitchFavorite}
        />
        {suppliersCount > limit && (
          <Pagination
            pages={this.props.pages}
            page={this.props.page}
            onSwitchPage={this.props.onSwitchPage}
          />
        )}
      </div>
    );
  }
}

export default withRouter(SuppliersListContainer);



// WEBPACK FOOTER //
// ./src/container/supplier/SuppliersListContainer/index.js